import { WppTopbar } from '@platform-ui-kit/components-library-react'
import clsx from 'clsx'
import { ComponentProps } from 'react'

import styles from 'layout/subheader/Subheader.module.scss'

export const Subheader = ({ className, ...rest }: ComponentProps<typeof WppTopbar>) => (
  <WppTopbar className={clsx('os-subheader', styles.topbar, className)} {...rest} />
)
